export default "__VITE_ASSET__d56ee902__"